import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function ExpenseReport(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [expenseData, setexpenseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};

 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchData();
  }, [startDate, endDate]);


  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}expense-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setexpenseData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
    const rows = expenseData.map((item) => {
    return {
      id: item.id,
      date_time: `${item.add_date_date} ${item.add_time}`,
      receipt: item.receipt,
      type: item.type,
      amount: item.amount,
      mode: item.mode,
      reason: item.reason,
      addedby: item.addedby,
    };
    });

  const columns = [
    { field: 'date_time', headerName: 'Date', width: 200 },
    { field: 'receipt', headerName: 'Expense Receipt', width: 200 },
    { field: 'type', headerName: 'Type', width: 120 },
    { field: 'amount', headerName: 'Amount', width: 100 },
    { field: 'mode', headerName: 'Mode', width: 120 },
    { field: 'reason', headerName: 'Reason', width: 200 },
    { field: 'addedby', headerName: 'Added By', width: 100 },
  ];

  const getTotal = (rows, field) => {
    return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
  };

   const Footer = ({ rows }) => {
      const totalBalance = getTotal(rows, 'amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalBalance}</div>
        </div>
      );
    };
    const today = new Date();
  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Expense Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={today}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />

            </div>
          </div>
        </div>
      </div>

      {!isLoading && expenseData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}

            autoHeight
          />
          <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <Footer rows={rows} />
            </tfoot>
          </table>
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default ExpenseReport;
